import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders';

export function loadSession({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("getSession", { id: params.session_id }).then(function({ data }) {
      resolve({data: data, session_id: params.session_id});
    }).catch((error) => {
      if (error.status == 404) {
        reject({text: "Session not found", path: "/scenarios", status: 404 });
      } else {
        reject(error);
      }
    });

  })
}

export function createMessage({ session_id, text = null, to, action_type = null, action_data = null, conversation_message_count }) {
  return new Promise(function(resolve, reject) {

    publicAction("createMessage", { session_id, text, to, action_type, action_data, conversation_message_count }).then(resolve).catch((error) => {
      if (error.status == 409) {
        reject(new Error("Message count mismatch"));
      } else {
        reject(error);
      }
    })

  })
}

export function updateMessage({ session_id, message_id, to, response_data = null }) {
  return new Promise(function(resolve, reject) {

    publicAction("updateMessage", { session_id, message_id, to, response_data }).then(resolve).catch((error) => {
      if (error.status == 409) {
        reject(new Error("Message count mismatch"));
      } else {
        reject(error);
      }
    })

  })
}

export function newConsult({ session_id, name }) {
  return publicAction("newConsult", { session_id, name })
}

export function addDifferential({ session_id, name, why }) {
  return publicAction("addDifferential", { session_id, name, why })
}

export function ruleOutDifferential({ session_id, id, why }) {
  return publicAction("ruleOutDifferential", { session_id, id, why })
}

export function renameDifferential({ session_id, id, name, why }) {
  return publicAction("renameDifferential", { session_id, id, name, why })
}

export function concludeEncounter({ session_id, differential_ids }) {
  return publicAction("concludeEncounter", { session_id, differential_ids })
}

export function saveSession({ session_id, data }) {
  return publicAction("saveSession", { id: session_id, data })
}

export function sessionSubmit({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(data) {

      publicAction("submitSession", { data: data, id: params.session_id }).then(({ data }) => {
        resolve({success: true, data});
      }).catch(() => {
        resolve({success: false, date: Date.now()});
      })

    })
  })
}

export function previewScenario({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("previewScenario", { id: params.scenario_id }).then(({ data }) => {
      resolve(redirect('/session/'+data.session_id))
    }).catch((error) => {
      if (error.status == 404) {
        reject({text: "Scenario not found", path: "/scenarios", status: 404 });
      } else {
        reject(error);
      }
    })

  })
}

export function previewAssessment({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("previewAssessment", { id: params.assessment_id, course_id: params.course_id }).then(({ data }) => {
      resolve(redirect('/session/'+data.session_id))
    }).catch((error) => {
      if (error.status == 404) {
        reject({text: "Assessment not found", path: "/courses/"+params.course_id, status: 404 });
      } else {
        reject(error);
      }
    })

  })
}

export function startAssessment({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("startAssessment", { id: params.assessment_id, course_id: params.course_id }).then(({ data }) => {
      resolve(redirect('/session/'+data.session_id))
    }).catch((error) => {
      if (error.status == 404) {
        reject({text: "Assessment not found", path: "/courses/"+params.course_id, status: 404 });
      } else {
        reject(error);
      }
    })
    
  })
}